import { CatalogueFilterItem } from "./catalogue-filters.model";

export class ToggleCatalogueFilterItem {
  static readonly type = "[CatalogueFilters] Toggle catalogue filter item";
  constructor(public item: CatalogueFilterItem) {}
}
